import { Button, Spinner } from "@fluentui/react-components";
import type { MouseEvent, ReactElement } from "react";

interface GeneralOfficeActionProps {
  loading: boolean;
  icon: ReactElement;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  label: string;
  variant?: "primary" | "secondary";
}

const LOADING_OPACITY = 0.7;

export const GeneralOfficeAction = ({
  loading,
  icon,
  onClick,
  label,
  variant,
}: GeneralOfficeActionProps) => {
  const backgroundColor = variant === "primary" ? "#9e2fad" : "#696EB1";
  const buttonLabel = loading ? "Loading..." : label;

  return (
    <div className="mt-2 flex w-full justify-center">
      <Button
        appearance="primary"
        disabled={loading}
        icon={loading ? <Spinner size="extra-small" /> : icon}
        onClick={onClick}
        style={{
          alignItems: "center",
          backgroundColor: loading ? "#888" : backgroundColor,
          border: "none",
          borderRadius: "4px",
          color: "white",
          cursor: loading ? "wait" : "pointer",
          display: "flex",
          fontSize: "14px",
          gap: "5px",
          justifyContent: "center",
          maxWidth: "180px",
          opacity: loading ? LOADING_OPACITY : 1,
          padding: "5px 12px",
          width: "100%",
        }}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};
